import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useConsultantRole from '../hooks/useConsultantRole';
import { useModalConfirm } from '../hooks/useModalConfirm';
import { MarketDeleteButton } from '../util/buttons';
const ConsultantsWithAccess = _ref => {
  let {
    consultants = [],
    removeConsultantFromClaim,
    size = 'sm',
    isUnderReview,
    canRemoveConsultant,
    labelCols
  } = _ref;
  const [getConsultantRole] = useConsultantRole();
  const {
    t
  } = useTranslation();
  const confirmRemoveConsultant = useModalConfirm({
    type: 'delete',
    confirmationButtonText: consultant => consultant?.name,
    onConfirm: consultant => removeConsultantFromClaim(consultant)
  });
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement("h4", null, t('consultants'))), consultants.sort((a, b) => a.name.localeCompare(b.name)).filter(c => c.to_delete !== false).map(consultant => /*#__PURE__*/React.createElement(React.Fragment, {
    key: consultant.id
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: size === 'lg' ? 4 : 2,
      offset: labelCols ?? (size === 'lg' ? 2 : 1)
    }
  }, /*#__PURE__*/React.createElement("p", null, "- ", consultant.name, " ")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: size === 'lg' ? 4 : 2
    }
  }, /*#__PURE__*/React.createElement("p", null, "- ", t(getConsultantRole(consultant.role)), " ")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: size === 'lg' ? 2 : 5
    }
  }, canRemoveConsultant && /*#__PURE__*/React.createElement(MarketDeleteButton, {
    size: "sm",
    disabled: isUnderReview,
    onClick: () => confirmRemoveConsultant(consultant)
  })))));
};
export default ConsultantsWithAccess;